// extracted by mini-css-extract-plugin
export var option = "_8n-0";
export var optionCard = "_8n-f";
export var optionContent = "_8n-g";
export var optionIcon = "_8n-i";
export var optionIconBox = "_8n-h";
export var optionLabel = "_8n-j";
export var optionPill = "_8n-m";
export var optionPillBadge = "_8n-p";
export var optionPillIcon = "_8n-n";
export var optionPillLabel = "_8n-o";
export var optionRadio = "_8n-k";
export var optionRadioInner = "_8n-l";
export var optionReveal = "_8n-2";
export var optionRevealDelay0 = "_8n-3";
export var optionRevealDelay1 = "_8n-4";
export var optionRevealDelay10 = "_8n-d";
export var optionRevealDelay11 = "_8n-e";
export var optionRevealDelay2 = "_8n-5";
export var optionRevealDelay3 = "_8n-6";
export var optionRevealDelay4 = "_8n-7";
export var optionRevealDelay5 = "_8n-8";
export var optionRevealDelay6 = "_8n-9";
export var optionRevealDelay7 = "_8n-a";
export var optionRevealDelay8 = "_8n-b";
export var optionRevealDelay9 = "_8n-c";
export var optionSelected = "_8n-1";